import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Box, Checkbox,
  Chip,
  FormControl,
  Grid,
  InputLabel, ListItemText,
  MenuItem,
  Select
} from "@mui/material";
import { t } from "i18next";
import api from "../../../../../helpers/api/Api";
import ApiUrls from "../../../../../helpers/urls/ApiUrls";
import { showStatus } from "../../../../../helpers/api/errors/ShowStatus";
import EditModal from "../../../../../components/EditModal";

function NoCacheDomains({ site, setOpen, handleCloseModal }) {
  const domainList = useSelector(state => state.domain_list);
  const [selectedDomains, setSelectedDomains] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setDomains();
  }, []);

  const setDomains = () => {
    const ids = site.nocachedids;
    const domains = ids !== "" ? site.nocachedids.split(",") : [];
    let nums = domains.map(function(str) {
      return parseInt(str);
    });
    setSelectedDomains(nums);
  }

  const handleChange = (event) => {
    const { value } = event.target;
    setSelectedDomains(value);
  };

  const onConfirm = () => {
    setLoading(true);

    const fd = new FormData();
    fd.append("sid", site.id);

    let ds = "";
    selectedDomains.map((d, i) => {
      ds += d;
      if (i !== selectedDomains.length-1) ds += ",";
    });
    fd.append("nocachedids", ds);

    const snackArgs = {
      item: t("site.no_cache_domains"),
      op: t("global.edit")
    };

    api.post(ApiUrls.site.setCachedDomains, fd)
       .then((response) => {
         setLoading(false);
         showStatus(response.data.status, snackArgs);
         handleCloseModal();
         if (response.data.status === "success") {
           setOpen("");
         }
       })
       .catch((error) => {
         setLoading(false);
         showStatus("error", snackArgs);
       });
  }

  return (
     <EditModal
        title={t("site.no_cache_domains")}
        onEdit={onConfirm}
        loading={loading}
        modalOpen={true}
        setModalOpen={setOpen}
     >
       <Grid item md={2} />
       <Grid item md={8}>
         <FormControl fullWidth>
           <InputLabel id="domains-multiple" shrink>{t("domain.domains")}</InputLabel>
           <Select
              label={t("domain.domain")}
              labelId="domains-multiple"
              id="domains-multiple-select"
              multiple
              value={selectedDomains}
              onChange={handleChange}
              renderValue={(selected) => (
                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                   {selected.map((value) => (
                      <Chip key={value} color="info"
                            label={domainList?.find(e => e.id == value)?.name}
                      />
                   ))}
                 </Box>
              )}
           >
             {domainList.map(({ id, name }) => (
                <MenuItem key={id} value={id} className="select-multiple">
                  <Checkbox checked={selectedDomains.includes(id)} size="size" />
                  <ListItemText primary={name} />
                </MenuItem>
             ))}
           </Select>
         </FormControl>
       </Grid>
       <Grid item md={2} />
     </EditModal>
  )
}

export default NoCacheDomains;
